import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const clientGroupService = {
  getAll, getOne, create, update, remove,
}

export function getAll() { return apiHelper(API_URL).get('/client-groups') }
export function getOne(id) { return apiHelper(API_URL).get(`/client-groups/${id}`) }
export function create(data) { return apiHelper(API_URL).post('/client-groups', data) }
export function update(id, data) { return apiHelper(API_URL).put(`/client-groups/${id}`, data) }
export function remove(id) { return apiHelper(API_URL).delete(`/client-groups/${id}`) }
